import { render, staticRenderFns } from "./ActeListeNotificationsClientArea.vue?vue&type=template&id=1c2b242a&"
import script from "./ActeListeNotificationsClientArea.vue?vue&type=script&lang=js&"
export * from "./ActeListeNotificationsClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports